/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FulfillmentRequest
 */
export interface FulfillmentRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FulfillmentRequest
     */
    merchantIds?: Array<string>;
}

export function FulfillmentRequestFromJSON(json: any): FulfillmentRequest {
    return FulfillmentRequestFromJSONTyped(json, false);
}

export function FulfillmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FulfillmentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'merchantIds': !exists(json, 'merchantIds') ? undefined : json['merchantIds'],
    };
}

export function FulfillmentRequestToJSON(value?: FulfillmentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'merchantIds': value.merchantIds,
    };
}

